import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { ClientsComponent } from '../../pages/clients/clients.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';

export const clientsRoutes: Routes = [
  {
    path: 'clients',
    component: ClientsComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.clients', role: ['Admin', 'Supervisor','Agent','Sales'], account_type: ['broker'] },
  },
  {
    path: 'clients/:reference',
    component: ClientsComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.clients', role: ['Admin', 'Supervisor','Agent','Sales'], account_type: ['broker'] },
  },
  {
    path: 'clients/add',
    component: ClientsComponent ,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.clients', role: ['Admin', 'Supervisor','Agent','Sales'], account_type: ['broker'] },
  },
];


export function getFilteredClientsRoutes(accountType: string, role: string): Routes {
  return clientsRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
